import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20vibrant%20stylized%20comic%20book%20collage%20illustration%20with%20dynamic%20manga%20characters%2C%20speech%20bubbles%2C%20sparkles%20and%20smartphone%20frames%20arranged%20in%20a%20playful%20composition%2C%20warm%20coral%20orange%20amber%20and%20teal%20color%20palette%2C%20bold%20clean%20comic%20art%20style%2C%20energetic%20joyful%20mood%2C%20high%20detail%20editorial%20illustration&width=1600&height=900&seq=home-hero&orientation=landscape"
          alt="漫画软件应用精选推荐主题插画"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/85 via-background-950/70 to-background-950/40"></div>
      </div>

      <div className="relative mx-auto flex min-h-[480px] w-full max-w-6xl flex-col items-start justify-center px-4 py-16 md:min-h-[600px] md:px-6">
        <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-500/20 px-4 py-1.5 text-sm font-bold text-secondary-300">
          <i className="ri-fire-fill" aria-hidden="true"></i>
          漫画软件应用排行 · 推荐 · 大全
        </span>
        <h1 className="mt-5 max-w-2xl font-heading text-3xl leading-tight text-background-50 md:text-5xl">
          漫画软件应用哪个好？
          <span className="text-secondary-300">一网打尽</span>帮你选对
        </h1>
        <p className="mt-5 max-w-xl text-base leading-relaxed text-background-100 md:text-lg">
          整理漫画软件应用排行与热门推荐，收录漫画软件应用大全与合集。从找漫画、追更到看热门作品，帮你快速锁定真正好用的漫画软件应用。
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/rankings"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-primary-500 px-7 py-3 text-base font-bold text-background-50 transition-colors hover:bg-primary-400"
          >
            查看完整排行榜
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
          <Link
            to="/reviews"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg border-2 border-background-50/70 px-7 py-3 text-base font-bold text-background-50 transition-colors hover:bg-background-50 hover:text-foreground-950"
          >
            浏览评测推荐
          </Link>
        </div>

        <dl className="mt-10 flex flex-wrap gap-8">
          {[
            { num: "9+", label: "精选应用" },
            { num: "6", label: "深度评测" },
            { num: "6类", label: "追更分类" },
            { num: "100%", label: "实用内容" },
          ].map((s) => (
            <div key={s.label} className="flex flex-col">
              <dd className="font-heading text-3xl text-secondary-300 md:text-4xl">{s.num}</dd>
              <dt className="mt-1 text-sm text-background-200">{s.label}</dt>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}